import { render, staticRenderFns } from "./GallerySelector.vue?vue&type=template&id=31a504f8&"
import script from "./GallerySelector.vue?vue&type=script&lang=js&"
export * from "./GallerySelector.vue?vue&type=script&lang=js&"
import style0 from "./GallerySelector.vue?vue&type=style&index=0&id=31a504f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports